import { Box, Typography } from '@mui/material'
import { styled } from '@mui/system'

export const Summary = styled(Typography)({
  fontWeight: 500,
  marginBottom: 4
})

export const Row = styled(Box)({
  marginBottom: '24px'
})
